/**
 * Uses document.execCommand() instead of the Clipboard API
 * for increased browser support.
 *
 * See: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
 * @param {string} textToCopy
 */
const copyToClipboard = (textToCopy) => {
    const dummy = document.createElement("textarea");
    dummy.value = textToCopy;
    dummy.setAttribute("readonly", "");
    dummy.style.position = "absolute";
    dummy.style.left = "-9999px";
    document.body.appendChild(dummy);

    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
};

export default copyToClipboard;
